module.exports = __webpack_public_path__ + "img/landing.2b74e937.jpg";